<div class="filter">
    <section class="filter__title">
        <p>{{filterTitle}}</p>

        <div class="filter__all">
            <div class="form">
                <div class="form__check mt-0" (click)="onAllClicked()">
                   <!-- <a class="link-all-selected" (click)="onCheckAll()">hola</a> -->
                    <input type="checkbox" id="{{filterTitle}} {{filterResult}}" >
                    <label class="link-all-selected" for="{{filterTitle}} {{filterResult}}">
                      <!-- <div class="fakebox"></div> -->
                      Todas
                  <!-- {{listFilterAll.value ?   'Ninguna' :'Todas'}} -->
                  </label>
                </div>
            </div>
        </div>
    </section>
    <div class="filter__body">
        <app-loader class="loader-element-list" *ngIf="gettingItemsList"></app-loader>
        <p style="text-align: center !important;" *ngIf="gettingItemsListError !== 'DEFAULT_VALUE' && !gettingItemsList "> {{gettingItemsListError}} </p>
        <div class="form" *ngIf="itemsList.length > 0 && !gettingItemsList">
          <div class="form__check mt-0" *ngFor="let control of itemControls.controls; let i = index"  >
                <input
                  type="checkbox"
                  [value]="control.value.id"
                  id="{{control.value.name}}{{control.value.id}}{{filterResult}}"
                  [formControl]="getCheckFormControl(control.value.id)"
                 />
                <label for="{{control.value.name}}{{control.value.id}}{{filterResult}}">
                <div class="fakebox fakebox--grey"></div>
                    {{control.value.name}}
                </label>
            </div>
        </div>
    </div>
</div>
